/* jshint esversion: 6 */
/* jshint ignore:start */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentResponse = () => {
    const navigate = useNavigate();
    const processed = useRef(false);

    useEffect(() => {

        if (processed.current) return;

        const url = new URL(window.location.href);
        const statusCode = url.searchParams.get('status_code');
        const orderId = url.searchParams.get('order_id');
        const transactionId = url.searchParams.get('transaction_id');
        const statusCode2 = url.searchParams.get('status');

        processed.current = true;

        if (statusCode === "200" || statusCode2 === "Completed") {
            handlePaymentSuccess(orderId, transactionId);
        } else {
            handlePaymentFailure();
        }

    }, []);

    const handlePaymentSuccess = (orderId, transactionId) => {
        const previousPage = sessionStorage.getItem("pages");
        sessionStorage.setItem("Paymentstatus", "PaymentDone");
        sessionStorage.setItem("transactionid", orderId || transactionId);

        if (previousPage === "0") {
            navigate("/wallet");
        } else {
            navigate("/cart");
        }
    };

    // Handle failed payment
    const handlePaymentFailure = () => {
        sessionStorage.setItem("Paymentstatus", "paymentfaild");
        const previousPage = sessionStorage.getItem("pages");

        if (previousPage === "0") {
            navigate("/wallet");
        } else {
            navigate("/cart");
        }
    };

    return null;
};

export default PaymentResponse;
/* jshint ignore:end */